import type { PapiUser } from '@wix/da-papi-types';

export interface LightweightPapiUserForMentionExtension {
  username: PapiUser['username'];

  // Because we can use the space key to force a mention to be created,
  // we might not have the userId and type fields available.
  userId?: PapiUser['userId'];
  type?: PapiUser['type'];
  icon?: PapiUser['usericon'];
}

export function toLightweightPapiUserForMentionExtension(
  user: PapiUser
): LightweightPapiUserForMentionExtension {
  return {
    icon: user.usericon,
    username: user.username,
    userId: user.userId,
    type: user.type,
  };
}
